module.exports = __webpack_public_path__ + "static/img/v21DetailImg.7479348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v21DetailImg.png
// module id = MQYT
// module chunks = 1